import { apiGet, apiPost } from './default'

function getFinancialInformation(isCapital,isCustomerMoneySegregationComputations,
    isFutureCustomerConcentration,isFutureMarginRequirements) {
    let query = '/regulatoryinformation/index.php?isCapital=' + isCapital;
    query += '&isCustomerMoneySegregationComputations=' + isCustomerMoneySegregationComputations;
    query += '&isFutureCustomerConcentration=' + isFutureCustomerConcentration;
    query += '&isFutureMarginRequirements=' + isFutureMarginRequirements;
    return apiGet(API_RESPONSE + query);
}

export default {
    getFinancialInformation
}
